import { Dispatch } from 'react';
import { FormInstance } from 'antd';

import { SnapDisplayComment } from 'codegen';

import { initialValues } from './handler';

export const handleSuccessPostComment = (
  form: FormInstance<typeof initialValues>,
  setComments: Dispatch<SnapDisplayComment[] | undefined>,
) => (
  { data: { comments } }: { data: { comments: SnapDisplayComment[] } },
) => {
  setComments(comments);
  form.resetFields();
};
